import { InformationCircleIcon } from "@heroicons/react/24/outline";

export function InfoTooltip({ text }: { text: string }) {
  return (
    <span className="relative group inline-flex" tabIndex={0} aria-label={text}>
      <InformationCircleIcon className="w-4 h-4 text-slate-500 cursor-help" />
      <span
        role="tooltip"
        className="pointer-events-none absolute top-full left-0 mt-1.5 z-20 w-64 rounded bg-gray-800 px-2 py-1 text-xs font-normal text-white opacity-0 transition-opacity group-hover:opacity-100 group-focus-within:opacity-100"
      >
        {text}
      </span>
    </span>
  );
}
